// Berufsbild-Detailseite: "Mehr zeigen" unter den Angebotskarten (Templates/Berufsbild/Show.html,
// Development/berufsbild-offers.md). Alle Karten sind im HTML, über data-step hinaus mit hidden;
// jeder Klick blendet die nächsten data-step Karten ein. Der Button ist ohne JavaScript ausgeblendet.
export function initBerufsbildOffers() {
  document.querySelectorAll('[data-berufsbild-offers]').forEach((section) => {
    const button = section.querySelector('[data-berufsbild-offers-more]');
    if (!button) return;

    const step = parseInt(section.dataset.step, 10) || 10;
    button.hidden = false;

    button.addEventListener('click', () => {
      const next = [...section.querySelectorAll('[data-berufsbild-offer][hidden]')].slice(0, step);
      next.forEach((item) => { item.hidden = false; });

      if (!section.querySelector('[data-berufsbild-offer][hidden]')) {
        button.hidden = true;
      }

      // Fokus auf die erste neue Karte, damit Tastatur-/Screenreader-Nutzer dort weiterlesen
      next[0]?.querySelector('a')?.focus();
    });
  });
}
